/*
  =====================================================
  Lee Flora Wholesale — Corporate Page JS
  FILE: assets/lfw-corporate.js
  SCOPE: Only loaded on page.corporate template
  =====================================================
*/

(function () {
  'use strict';

  // ── FAQ Accordion ──────────────────────────────────
  document.querySelectorAll('.lfw-faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.parentElement;
      // Close any open sibling in the same FAQ section
      var section = item.closest('.lfw-corp-faq');
      if (section) {
        section.querySelectorAll('.lfw-faq-item.lfw-open').forEach(function (open) {
          if (open !== item) open.classList.remove('lfw-open');
        });
      }
      item.classList.toggle('lfw-open');
    });
  });

  // ── Scroll Animate ─────────────────────────────────
  var animateEls = document.querySelectorAll('.lfw-animate');
  if (animateEls.length > 0) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lfw-show');
          observer.unobserve(entry.target); // fire once
        }
      });
    }, { threshold: 0.15 });

    animateEls.forEach(function (el) {
      observer.observe(el);
    });
  }
})();
